<template>
  <v-app>
    <v-row class="justify-center ma-0">
      <div class="d-flex justify-center align-center flex-column" v-if="isLoading">
        <p>Carregando...</p>
        <v-progress-circular indeterminate color="primary" class="mb-0"></v-progress-circular>
      </div>
      <v-col
        class="col-12 col-sm-12 col-md-11 col-lg-11"
        v-if="!isLoading"
        :class="{
          'pt-3': $vuetify.breakpoint.smAndDown,
          'pt-5': $vuetify.breakpoint.mdAndUp,
        }"
      >
        <v-container>
          <v-row class="justify-center align-center my-2" v-if="category == 'psychologist'">
            <v-col class="col-12 col-md-5">
              <h2 class="mx-2 text-center text-md-left">Perfil</h2>
            </v-col>
            <v-col class="col-12 col-md-5">
              <v-row
                :class="{
                  'justify-space-around': $vuetify.breakpoint.smAndDown,
                  'justify-end': $vuetify.breakpoint.mdAndUp,
                }"
              >
                <v-btn
                  color="gray"
                  to="/change-password"
                  dark
                  :class="{ 'mr-3': $vuetify.breakpoint.mdAndUp }"
                  >{{ $t('pageProfile.btnSenha') }}</v-btn
                >
                <v-btn color="gray" dark to="edit-profile">Editar Perfil</v-btn>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="justify-center align-center my-2" v-if="category != 'psychologist'">
            <v-col class="col-md-5">
              <v-row class="aling-center ma-0">
                <v-img
                  :src="require('../../assets/ear_32x32.png')"
                  max-width="32"
                  max-height="32"
                ></v-img>
                <h2 class="mx-2 text-center text-md-left">Psicólogo</h2>
              </v-row>
            </v-col>
            <v-col class="col-md-5 text-sm-right">
              <v-btn color="secondary" :to="{ path: '/psicologo/scheduling/' + user.id }"
                >AGENDAR CONSULTA</v-btn
              >
            </v-col>
          </v-row>
          <v-row class="justify-center">
            <v-col class="col-12 col-md-4 px-3">
              <v-col class="col-12 d-flex align-center justify-end">
                <div
                  class="pl-12"
                  style="
                    background: #fffde3;
                    padding: 13px 0;
                    border-radius: 12px;
                    width: calc(100% - 46px);
                    position: relative;
                  "
                >
                  <div style="position: absolute; left: -50px; top: 0">
                    <v-avatar size="90">
                      <v-img v-if="user.photo != ''" :src="user.photo">
                        <template v-slot:placeholder>
                          <v-row fill-height align-center justify-center ma-0>
                            <v-progress-circular
                              indeterminate
                              color="primary"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>

                      <v-img
                        v-if="user.photo == ''"
                        :src="require('../../assets/no-image.png')"
                      ></v-img>
                    </v-avatar>
                  </div>
                  <p class="mb-2 font-weight-bold subheading">{{ user.name }}</p>
                  <p class="ma-0">
                    <span class="font-weight-bold">Nacionalidade:</span>
                    {{ user.country }}
                  </p>
                </div>
              </v-col>
              <div class="d-flex mt-4">
                <v-col class="col-6 ml-2">
                  <p>
                    <span class="font-weight-bold">Sexo:</span>
                    {{ user.gender }}
                  </p>
                </v-col>
                <v-col v-if="user.date_birth" class="col-6">
                  <p>
                    <span class="font-weight-bold">Nascimento:</span>
                    {{ user.date_birth }}
                  </p>
                </v-col>
              </div>
              <v-divider></v-divider>
              <div class="d-flex mt-4">
                <v-col class="col-6 ml-2">
                  <p>
                    <span class="font-weight-bold">{{ $t('pageProfile.labelDestrito') }}:</span>
                    {{ user.state }}
                  </p>
                </v-col>
                <v-col class="col-6">
                  <p>
                    <span class="font-weight-bold">Cidade:</span>
                    {{ user.city }}
                  </p>
                </v-col>
              </div>
              <v-divider></v-divider>
              <div>
                <h3 class="my-4">{{ $t('pageProfile.titleContato') }}</h3>
                <div>
                  <div
                    class="mb-3 box-contact d-flex align-center justify-center"
                    v-if="user.email"
                  >
                    <span>Email</span>
                    <v-img
                      :src="require('../../assets/icon-mail.svg')"
                      width="28px"
                      class="mr-2"
                    ></v-img>
                    <p>{{ user.email }}</p>
                  </div>
                  <v-divider class="mb-3"></v-divider>

                  <div
                    class="mb-3 box-contact padding-16 d-flex align-center"
                    style="justify-content: center"
                  >
                    <span>Habilitações Académicas:</span>
                    <p>{{ user.academic_degree }}</p>
                  </div>

                  <div
                    class="mb-3 box-contact d-flex align-center justify-center"
                    v-if="user.is_chief_therapist"
                  >
                    <v-icon dark class="primary--text icon-psy-name" size="32">bookmark</v-icon>
                    <span class="primary--text">Terapeuta Chefe</span>
                  </div>

                  <div
                    class="mb-3 box-contact padding-16 d-flex align-center"
                    style="justify-content: center"
                  >
                    <span class="primary--text">Avaliação:</span>
                    <p>{{ average_rating }}</p>
                    <v-img
                      :src="require('../../assets/md-star.svg')"
                      width="40px"
                      class="mx-3"
                    ></v-img>
                  </div>

                  <div
                    class="mb-3 box-contact padding-16 d-flex align-center"
                    style="justify-content: center"
                  >
                    <v-img
                      :src="require('../../assets/icon-money.svg')"
                      width="32px"
                      class="mx-2"
                    ></v-img>
                    <span class="mx-2">Valor da Consulta:</span>
                    <p v-if="user.appointment_br_value != '0.00' && language === 'pt-BR'">
                      R$ {{ user.appointment_br_value }}
                    </p>
                    <p v-else>€ {{ user.appointment_pt_value }}</p>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col class="col-12 col-md-4 px-3">
              <div>
                <h3 class="my-4">Área de Atuação</h3>
                <v-row>
                  <v-col
                    class="shrink pa-1 my-2 col-auto"
                    v-for="(especiality, index) in specialities"
                    :key="index"
                  >
                    <span class="specialities">{{ especiality }}</span>
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <div class="mb-3 box-contact padding-16 d-flex align-center" v-if="user.opp && user.language === 'pt'">
                  <span>{{ $t('pageProfile.oppOrCrp') }}:</span>
                  <p>{{ user.opp }}</p>
                </div>

                <div class="mb-3 box-contact padding-16 d-flex align-center" v-if="user.crp && user.language === 'pt-BR'">
                  <span>{{ $t('pageProfile.oppOrCrp') }}:</span>
                  <p>{{ user.crp }}</p>
                </div>

                <div class="mb-3 box-contact align-center" v-if="user.biography">
                  <span>{{ $t('pageProfile.psiBio') }}:</span>
                  <p class="text-justify biographty-text">{{ user.biography }}</p>
                </div>
              </div>
            </v-col>
            <v-col class="col-12 col-md-4 px-3">
              <div v-if="category == 'psychologist' && user.digital_account">
                <div
                  class="box-contact padding-16 border-bottom d-flex align-center justify-space-between"
                >
                  <span>DADOS BANCÁRIOS</span>

                  <v-btn :to="{ name: 'EdicaoBancario' }" color="primary" class="rounded-lg px-5">
                    Editar
                  </v-btn>
                </div>
                <div class="border-bottom padding-16 d-flex align-center" v-if="language === 'pt'">
                  <span class="color-darkGray font-weight-bold">
                    Tipo da conta:
                    <span class="color-darkGray font-weight-regular">{{
                      user.digital_account.type_account === 'eni'
                        ? $t('dateBank.types.firstType')
                        : $t('dateBank.types.secondType')
                    }}</span>
                  </span>
                </div>
                <div class="border-bottom padding-16 d-flex align-center">
                  <span class="color-darkGray font-weight-bold">
                    {{ $t('dateBank.identifyNumber') }}:
                    <span class="color-darkGray font-weight-regular">{{
                      user.digital_account.vat_number
                    }}</span>
                  </span>
                </div>

                <template v-if="language === 'pt-BR'">
                  <div class="border-bottom padding-16 d-flex align-center">
                    <span class="color-darkGray font-weight-bold">
                      Conta bancária:
                      <span class="color-darkGray font-weight-regular">{{ bankName }}</span>
                    </span>
                  </div>
                  <div class="border-bottom padding-16 d-flex align-center">
                    <span class="color-darkGray font-weight-bold">
                      Número da agência:
                      <span class="color-darkGray font-weight-regular">{{ agencyNumber }}</span>
                    </span>
                  </div>
                </template>

                <div class="border-bottom padding-16 d-flex align-center">
                  <span class="color-darkGray font-weight-bold">
                    {{ $t('dateBank.numberAccount') }}:
                    <span class="color-darkGray font-weight-regular">{{
                      user.digital_account.iban_code
                    }}</span>
                  </span>
                </div>
                <div
                  class="border-bottom padding-16 d-flex align-center"
                  v-if="user.digital_account.company_representative != ''"
                >
                  <span class="color-darkGray font-weight-bold">
                    Representante da Empresa:
                    <span class="color-darkGray font-weight-regular">{{
                      user.digital_account.company_representative
                    }}</span>
                  </span>
                </div>
              </div>
              <div v-if="category == 'psychologist' && !user.digital_account">
                <div class="box-contact padding-16 border-bottom d-flex align-center">
                  <span>DADOS BANCÁRIOS</span>
                </div>
                <div
                  class="box-contact padding-16 d-flex flex-column align-center justify-center mt-5"
                >
                  <v-img
                    :src="require('../../assets/mao.svg')"
                    max-width="100"
                    max-height="100"
                  ></v-img>
                  <p class="ma-0 text-center gray--text text-body-1">
                    Cadastre sua conta bancária para<br />
                    começar a atender seus pacientes!
                  </p>

                  <v-btn class="mt-3" color="secondary" large @click="registerBankAccount" :to="{ name: 'CadastroBancario' }"
                    >Cadastrar</v-btn
                  >
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-app>
</template>

<script>
import moment from 'moment-timezone';
import { profileWithSlug, getProfile } from '../../services/psychologists';
import getLanguage from '../../utils/getLanguage';
import axios from 'axios'

export default {
  data: () => ({
    user: {},
    cod: '',
    specialities: [],
    banco: [],
    items: [{ text: 'Branco do Brasil' }],
    isEdit: true,
    isLoading: false,
    average_rating: '0/5',
    category: 'psychologist',
    language: '',
    bankNumber: '',
    bankName: '',
    agencyNumber: '',
  }),
  async created() {
    this.language = getLanguage(window.location.href);
  },
  async mounted() {
    await this.getCod();
    await this.getProfile();
    this.setBankAndAgencyNumber();
    await this.setBankName();
  },

  methods: {
    getCod() {
      this.category = localStorage.getItem('user-category');
      if (this.category === 'psychologist') {
        const localUser = JSON.parse(localStorage.getItem('user-data'));
        this.cod = localUser.id;
      } else {
        this.cod = this.$route.params.id;
      }
    },
    registerBankAccount() {
      if (!this.psi.is_active) {
        this.dialog = true;
        this.dialogTitle = 'Você precisa estar aprovado para poder criar a conta bancária como psicólogo.';
        this.dialogSubTitle =
          'Entre em contato por email: suporte@ondivan.com para saber o status da sua solicitação.';
        this.confirmErrorGoTo = 'DashboardPsicologo';
        return;
      }

    },
    setBankAndAgencyNumber() {
      if (this.user.digital_account.routing_number) {
        this.bankNumber = this.user.digital_account.routing_number.split('-')[0]
        this.agencyNumber = this.user.digital_account.routing_number.split('-')[1]
      }
    },
    async setBankName() {
      const { data } = await axios.get('https://brasilapi.com.br/api/banks/v1');
      const bank = data.find((bank) => bank.code == this.bankNumber)
      this.bankName = bank ? bank.name : '';
    },
    async getProfile() {
      try {
        this.isLoading = true;
        let user = null;
        if (this.category === 'psychologist') {
          user = await getProfile(this.cod, true);
        } else {
          user = await profileWithSlug(this.cod);
        }
        this.user = user;
        console.log(this.user);
        this.formatData(this.user.date_birth);
        this.specialities = user.specialities;
        if (user.average) {
          this.average_rating = `${user.average}/5`;
        }
        this.isLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    formatData(v) {
      this.user.date_birth = !v ? '' : moment(v).format('DD/MM/YYYY');
    },
    getOut() {
      localStorage.clear();
      this.$router.replace('/psicologo/login');
    },
    onEdit(value) {
      this.isEdit = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.box-contact {
  background-color: #f7f7f7;
  color: #6f6f6f;
  font-size: 18px;
  flex-wrap: wrap;

  > * {
    flex: 0 0 auto !important;
  }

  p {
    margin: 0;
  }

  span {
    font-size: 20px;
    margin-right: 20px;
    font-weight: bold;
  }
}

h2 {
  color: var(--v-primary-base);
}

.padding-16 {
  padding: 16px;
}

.border-bottom {
  border-bottom: 1px solid #e7e7e7;
}

.specialities {
  padding: 10px 15px;
  background: green;
  color: white;
  border-radius: 15px;
}

.photoOPP {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-self: center;
  border: solid 1px #707070;
  padding: 32px 16px;
  border-radius: 10px;
}

.biographty-text {
  white-space: pre-wrap;
  p {
    margin-bottom: 0;
  }
}
</style>
